import { Component, OnInit, OnDestroy } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { AcademyService } from "../academies/service/academies.service";
import { BatchService } from "src/app/services/batch.service";
import { ReportService } from "src/app/services/report.service";
import { CategoryService } from "src/app/services/category.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-performance-analytics',
  templateUrl: './performance-analytics.component.html',
  styleUrls: ['./performance-analytics.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class PerformanceAnalyticsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  batchCategoryList: any;
  months = environment.months;
  batchPlayers: any = [];
  yearlist: any = [];
  errorMessage = "";
  searchBy: any[];
  totalRecords: 0;
  loading: boolean;
  paginationOption;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadPerformanceAnalyticsReportList: any;
  searchby;
  public hide: boolean = true;
  academiesList: any;
  academyId: any;
  performanceAnalyticsData: Object;
  batch:any;
  username: string;
  year:number;
  month:number;
  category:string;

  constructor(
    private messageService: MessageService,
    private academyService: AcademyService,
    private categoryService: CategoryService,
    private batchService: BatchService,
    private reportService: ReportService
  ) {}

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Created On', value: "created_at" }
    ];
    this.downloadFlg = false;
    var currentYear = new Date().getFullYear();
    for (let i = currentYear; i <= 2040; i++) {
      this.yearlist.push({ label: i, value: i });
    }
    this.getAcademies();
    this.getBatchCategories();
  }

  
  getAcademies() {
    let query = "?filterByDisable=false&filterByStatus=true";
    this.academyService.getAcademyList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.academiesList = data.data.items;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getBatchPlayers(event) {
    const academyId = event.value;
    let query = "filterByDisable=false&filterByStatus=true&filterByAcademyId=" + academyId;
    this.batchService.getBatchPlayerList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.batchPlayers = data?.data?.items;
    }, err => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Batch Player failed', life: 6000 });
    })
    this.loadPerformanceAnalytics(this.lastTableLazyLoadEvent);
  }

  getBatchCategories() {
    const query = `?filterByDisable=false&getSubcategory=true&filterByParentCategory=Batch Category`;
    this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
        this.batchCategoryList = data?.data?.items;
    }, err => {
        this.errorMessage = err.error.message;
    })
  }
  
  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.academyId = null;
    this.batch = null;
    this.username = null;
    this.month = null;
    this.year = null;
    this.category = null;
    this.loadPerformanceAnalytics(this.lastTableLazyLoadEvent);
  }

  loadPerformanceAnalytics(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
        params += "&filterByDate=" + this.searchby.value;
        params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
        params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (this.academyId) {
      params += "&filterByAcademy=" + this.academyId;
    }

    if (this.batch) {
      params += "&filterByBatch=" + this.batch.id;
    }

    if (this.username) {
      params += "&filterByUsername=" + this.username;
    }

    if (this.month) {
      params += "&filterByMonth=" + this.month;
    }
    
    if (this.year) {
      params += "&filterByYear=" + this.year;
    }

    if (this.category) {
      params += "&filterByCategory=" + this.category;
    }

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.reportService.getPerformanceAnalytics(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data:any) => {
         if (this.downloadFlg === false) {
          this.performanceAnalyticsData = data.data;
          this.totalRecords = data.totalCount;
        } else {
          this.exportPerformanceAnalyticsListData(data.data);
          this.downloadFlg = false;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadPerformanceAnalytics(this.lastTableLazyLoadEvent);
  }

  async exportPerformanceAnalyticsListData(performanceAnalyticsReportList) {
    this.downloadPerformanceAnalyticsReportList = performanceAnalyticsReportList;
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadPerformanceAnalyticsReportList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "Performance_Analytics_Report");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  /**
   * Use to add more columns in the table.
   */
  addColumns() {
    this.hide = false;
  }

  /**
   * Use to remove more columns in the table.
   */
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
